import React from 'react'
import { useState } from 'react'
import { Alert, Button, Collapse } from 'reactstrap'
import Accordion from '../../../../components/AccordionCommon/Accordion'

export default function QuestionPreviewStep({
  partsData,
  handleTryAgain,
  handleContinue,
  loading,
  customText,
  modifyCustomText,
  handleGenerateAgain,
}) {
  const [showTryAnotherPrompt, setShowTryAnotherPrompt] = useState(false)

  const validQuestions =
    partsData[0] &&
    partsData[0].questions &&
    Array.isArray(partsData[0].questions)

  const generatedQuestions = (height) => {
    return (
      <div style={{ maxHeight: `${height}px`, overflowY: 'auto' }}>
        <h5>
          <span style={{ fontWeight: '800' }}>[Preview]</span>{' '}
          {partsData[0].name}
        </h5>
        <div className="mt-3">
          <ol className="trivvy-ai-gen-survey-preview-container">
            {partsData[0] &&
            partsData[0].questions &&
            Array.isArray(partsData[0].questions) ? (
              partsData[0].questions.map((x) => (
                <li>
                  <h5>{x.question}</h5>

                  {x.scaleConfigs && x.scaleConfigs.min ? (
                    <div className="my-2">
                      Rate: {x.scaleConfigs.min} to {x.scaleConfigs.max}
                    </div>
                  ) : (
                    ''
                  )}

                  {x.options && x.options.length ? (
                    <div className="my-2 trivvy-ai-gen-survey-preview-options-container">
                      {x.options.map((c) => (
                        <div>
                          {' '}
                          <input type="radio" /> {c}{' '}
                        </div>
                      ))}
                    </div>
                  ) : (
                    ''
                  )}

                  {x.source ? <div className="my-2"> {x.source} </div> : ''}
                </li>
              ))
            ) : (
              <div className="text-center">No questions generated</div>
            )}
          </ol>
        </div>
      </div>
    )
  }

  if (showTryAnotherPrompt) {
    return (
      <div>
        <h4>Try another prompt.</h4>

        <div className="mt-3">
          {customText && customText.length < 40 ? (
            <Alert color={'danger'}>
              Your custom input must be greater than 40 characters.
            </Alert>
          ) : (
            ''
          )}
          <span className="bwai-txtarea-desc">
            **Tell us what you want to find out. Please note you’ll get a better
            survey, the more specific you can be{' '}
            <span className="language-support-text">(1000 characters max)</span>{' '}
          </span>
          <textarea
            value={customText}
            onChange={(e) => {
              let val = e.target.value

              modifyCustomText(val.slice(0, 1000))
            }}
            rows={8}
            className="w-100"
            placeholder="Type in what you need to find out"
          />
          {customText ? (
            <small className="float-right bwai_counter">
              {customText.length}/1000
            </small>
          ) : (
            ''
          )}
        </div>

        <div className="mt-5">
          {validQuestions ? (
            generatedQuestions(300)
          ) : (
            <div className="text-center">
              {' '}
              Questions are not generated , Please try again.{' '}
            </div>
          )}
        </div>

        {validQuestions && (
          <div>
            {loading ? (
              <div>
                <div className="text-center my-4">
                  {' '}
                  <h6>
                    Please wait while generating trivvys from these questions
                  </h6>{' '}
                </div>
              </div>
            ) : (
              <div className="d-flex justify-content-end my-4">
                <Button
                  className="trivia-action-button-main-secondary mr-2"
                  onClick={() => setShowTryAnotherPrompt(false)}>
                  Back
                </Button>

                <Button
                  color="success"
                  className="mr-2"
                  onClick={() => {
                    handleGenerateAgain()
                    setTimeout(() => {
                      setShowTryAnotherPrompt(false)
                    }, 4000)
                  }}
                  style={{ height: '33px' }}>
                  Generate again
                </Button>

                <Button
                  className="trivia-action-button-main"
                  onClick={() => handleContinue()}>
                  Continue
                </Button>
              </div>
            )}
          </div>
        )}
      </div>
    )
  } else {
    return (
      <div>
        {/* <h4>Preview your survey.</h4> */}

        {validQuestions ? (
          generatedQuestions(500)
        ) : (
          <div className="text-center">
            {' '}
            Questions are not generated , Please try again.{' '}
          </div>
        )}

        <hr className="my-3" />

        {validQuestions && (
          <div>
            {loading ? (
              <div className="text-center">
                {' '}
                <h6>
                  Please wait while generating trivvys from these questions
                </h6>{' '}
              </div>
            ) : (
              <div className="d-flex justify-content-between align-items-center py-4">
                <Button
                  outline
                  color="primary"
                  style={{ height: '33px' }}
                  onClick={() => setShowTryAnotherPrompt(true)}>
                  Try another prompt
                </Button>{' '}
                <Button
                  onClick={handleContinue}
                  className="trivia-action-button-main">
                  Continue
                </Button>
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
}
